import { createStyles, makeStyles } from '@material-ui/core';
import { Colors } from '../../../../layout/theme-next';

export default makeStyles((theme) =>
  createStyles({
    root: {
      pointerEvents: 'none',
    },
    paper: {
      pointerEvents: 'auto',
      width: '80vw',
      padding: theme.spacing(3),
      height: '90vh',
    },
    columnNameInput: {
      fontSize: '16px',
    },
    fullWidth: {
      width: '100%',
    },
    genericFlex: {
      display: 'flex',
      alignItems: 'center',
      gap: `${theme.spacing(1)}px`,
    },
    genericColumnFlex: {
      display: 'flex',
      flexDirection: 'column',
      gap: `${theme.spacing(1)}px`,
    },
    loadingContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    },
    actionBtns: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(1),
      borderTop: `1px solid ${Colors.lightGray}`,
    },
    btnGroup: {
      display: 'flex',
      gap: `${theme.spacing(1)}px`,
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    optionName: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      color: Colors.textBlack,
    },
    chipOptions: {
      display: 'flex',
      gap: `${theme.spacing(1)}px`,
      flexShrink: 0,
    },
    optionDetails: {
      position: 'relative',
      top: '-2px',
      color: Colors.textGray,
    },
    validationError: {
      color: Colors.error,
      fontSize: theme.spacing(1.75),
      lineHeight: 1.7,
    },
    check: {
      fontSize: 18,
      color: Colors.success,
      fontWeight: 600,
      marginRight: theme.spacing(0.5),
    },
    dialogHeader: {
      fontSize: 20,
      fontWeight: 600,
      marginBottom: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
    dialogContent: {
      padding: theme.spacing(1, 2.5),
    },
    subtitle: {
      fontSize: 14,
      marginBottom: theme.spacing(0.25),
    },
    mappingArea: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: theme.spacing(3),
      '& > div > div': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        marginBottom: theme.spacing(1),
      },
    },
    spaceBetweenFlex: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: `${theme.spacing(1)}px`,
    },
    mappingAreaTitle: {
      display: 'inline-block',
      marginBottom: theme.spacing(1),
      color: Colors.textBlack,
      fontWeight: 400,
      fontSize: 14,
      textDecoration: 'underline',
    },
    editableFieldsChip: {
      height: theme.spacing(3),
      fontSize: '0.75rem',
      fontWeight: 500,
      marginLeft: theme.spacing(2),
    },
    fromRevContainer: {
      width: '32%',
    },
    toStageContainer: {
      width: '56%',
    },
    toSchemaItem: {
      display: 'flex',
      flexWrap: 'wrap',
      alignContent: 'flex-start',
      gap: `${theme.spacing(1)}px`,
      overflow: 'auto',
      minHeight: theme.spacing(20),
    },
    selectedFromSchemaItem: {
      color: Colors.success,
      position: 'absolute',
      right: 6,
      top: theme.spacing(1),
      fontSize: 18,
    },
    doneAllIcon: {
      color: Colors.approve,
      position: 'relative',
      top: 6,
    },
    chip: {
      fontSize: theme.spacing(1.5),
      padding: theme.spacing(0, 0.5),
      height: 28,
      margin: theme.spacing(0, 0.5, 0.5, 0),
      '& > span.chip-delete': {
        background: Colors.remove,
      },
    },
    mappingView: {
      maxHeight: '60vh',
      overflow: 'auto',
    },
    mappingInfo: {
      marginBottom: theme.spacing(1),
    },
    pointer: {
      cursor: 'pointer',
    },
    isRequired: {
      color: Colors.error,
      fontSize: 16,
    },
    mappingRuleSchemaItemBox: {
      position: 'relative',
      marginTop: theme.spacing(1),
      border: `1px solid ${Colors.lightGray}`,
      borderRadius: theme.spacing(0.25),
      padding: theme.spacing(1),
      width: '100%',
    },
    schemaItemLabel: {
      fontSize: 14,
      fontWeight: 400,
    },
    simpleFlex: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    selectControl: {
      marginLeft: 0,
      gap: `${theme.spacing(1)}px`,
    },
  }),
);
